<template>
  <section style="padding:20px;">
  <div class="dashboard-container">

	<div class="hw_account_content">
		<el-row style="height:40px;line-height:40px;margin:20px 0px;">
		  <el-col :span="20">
		    <el-radio-group size="small" fill="#50bfff" @change="handleCurrentChange" v-model="channel">
			   <el-radio-button label="all">全部渠道</el-radio-button>
			   <el-radio-button label="1">TouTiao</el-radio-button>
			   <el-radio-button label="2">Facebook</el-radio-button>
			   <el-radio-button label="3">Adwords</el-radio-button>
			   <el-radio-button label="4">Tiktok</el-radio-button>
			</el-radio-group>
			<el-input size="small" placeholder="搜索广告账户ID" v-model="advertiser_id" clearable class="input-with-select">
			 <el-button slot="append" @click="search" icon="el-icon-search"></el-button>
			</el-input>
	      </el-col>
		  
		  <el-col :span="4">
		    <el-select size="small" v-model="product_id" @change="handleCurrentChange" placeholder="选择产品">
				<el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
			  </el-select>
		  </el-col>
		</el-row>
		<el-row>
			<el-table :data="list" highlight-current-row v-loading="listLoading"  style="width: 100%;">				
				<el-table-column label="账户ID" width="200px">
				   <template slot-scope="scope">
						<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="right">
						  <el-link @click="OpenPromotion(scope.row)" type="primary">{{scope.row.advertiser_id}}</el-link>
						 </el-tooltip>
					</template>
				</el-table-column>				
				<el-table-column label="名称" width="200px" align="left">
				 <template slot-scope="scope">					 
					 {{scope.row.name}}
				</template>
				</el-table-column>
				<el-table-column label="渠道" align="center">				 
					<template slot-scope="scope">
					  <i v-if="scope.row.channel==2" style="color:#409EFF;" class="fa fa-facebook"></i>
					  <i v-else-if="scope.row.channel==3" style="color:#e84a5f;" class="fa fa-google"></i>
					  <i v-else-if="scope.row.channel==1" style="color:#ff1e56;font-style:normal;font-weight:700">TouTiao</i>
					  <i v-else-if="scope.row.channel==4" style="color:#f54291;font-style:normal;font-weight:700">Tiktok</i>
					</template>
				</el-table-column>
				<el-table-column  width="100px" label="产品" align="left">
				  <template slot-scope="scope">					 
				       <img class="ads_icon" :title="scope.row.product.name" style="vertical-align:middle;" :src="scope.row.product.icon" />
				</template>
				</el-table-column>
                <el-table-column label="创建者" prop="updateuser" align="center"></el-table-column>				
				<el-table-column label="创建时间" prop="updatetime" align="center"></el-table-column>
				<el-table-column label="操作" align="center">
				 <template slot-scope="scope">					 
					  <el-button @click="adv(scope.row)"  type="text" size="small">进入广告管理>></el-button>
				</template>
				</el-table-column>
			</el-table>
			<el-col :span="24" class="toolbar">			
			  <el-pagination  layout="total,prev, pager, next"  @current-change="handleCurrentChange"  :current-page.sync="page" :page-size="10" :total="total" style="float:right;"></el-pagination>
		    </el-col>			
		</el-row>
	</div>
  </div>
  </section>
</template>

<script>
import { MainListPage,getProductListData } from '../api/api';
	export default {
	  data() {
		return {
		   channel:'all',
		   total:0,
		   page:1,
		   advertiser_id:'',
		   product_id:'',
		   listLoading:false,
		   productList:[],
		   list:[]
		}
	  },
	  computed:{
	     userid(){
		   return this.$store.getters.getUserId
		 }
	  },
	  created(){
	    this.getAdsAccount()
	  },
	  methods:{
	    handleCurrentChange(){
		  this.getAdsAccount()
		},
		getProduct(){            
			let params ={
			    userid:this.userid
			}
			getProductListData(params).then((res) => {
			   this.productList = res.data.list;
			});
		},
		getAdsAccount(){            
			  let para = {
					page: this.page,
					userid:this.userid,
					product_id:this.product_id,
					advertiser_id: this.advertiser_id,
					channel:this.channel
				};
				this.listLoading = true;
				MainListPage(para).then((res) => {
					this.total = res.data.total;
					this.list = res.data.list;
					this.listLoading = false;
					this.dates = []
					this.dates.push(res.data.start_date,res.data.end_date)
				});			
		},
		OpenPromotion(row){
		  this.$store.commit('UpdateActive',2)
		  let channel = row.channel==1?"toutiao":row.channel==2?"facebook":row.channel==3?"adwords":"tiktok";
		  this.$router.push(`/${channel}/${row.advertiser_id}`)
		},
        adv(row){
		  this.$store.commit('UpdateActive',2)
		  let channel = row.channel==1?"toutiao":row.channel==2?"facebook":row.channel==3?"adwords":"tiktok";
		  this.$router.push(`/${channel}/${row.advertiser_id}`)
		},		
		search(){
		  this.getAdsAccount()
		}
	  },
	  mounted()
	  {
		this.getAdsAccount()
		this.getProduct()
	  }
	}

</script>

<style scoped lang="scss">
 .hw_account_content{
    width:90%;
	margin:0 auto;
	.el-input {
    width:250px;
  }
  .ads_icon{width:20px;height:20px;}
 .el-input-group__append {
    background-color: #fff;
  }
 }
</style>



// WEBPACK FOOTER //
// Main.vue?7a00be7c